import React from "react";
import Modal from "../index";
import {FlexContainer, Img, Text} from "../../../design";
import success from "../../../assets/imgs/success.svg";

type Props = {
  isOpen: boolean,
  partnerConnection: Boolean,
  successMsg: String,
  processing: Boolean,
}
const SuccessModal = (props : Props) => {
  return (
    <Modal isOpen={props.isOpen}>
        <FlexContainer
            height="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
            box-shadow="0 0 20px 0 rgba(0, 0, 0, 0.1)"
            backdropFilter='none'
            borderRadius='4px'
            backgroundColor="#f2f5f8"
            textAlign='center'
            alignContent='none'
        >
            <Img width='108px' height='108px' paddingBottom='25px' src={success} />
            <Text
                fontSize="20px"
                fontWeight='600'
            >
                {props.successMsg ? props.successMsg : (props.partnerConnection ? 'Partner Connection Completed' : (props.processing ? 'Payment placed successfully in the process': 'Transaction Complete'))}
            </Text>
            <Text
                fontSize="16px" textAlign="center" paddingLeft="14px" paddingRight="14px"
            >
                You will be redirected automatically.
            </Text>
        </FlexContainer>
    </Modal>
  )
};

export default SuccessModal;
